import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import PlayIcon from '../assets/play-icon.svg?react';
import PauseIcon from '../assets/pause-icon.svg?react';

const Button = styled.button`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        background-color: ${theme.colors['myzanichelli-blue-light']};
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        height: 100%;
        width: 48px;
        min-width: 48px;
        border: none;
        cursor: pointer;

        & > svg {
            width: 24px;
            height: 24px;
            fill: ${theme.colors['surface-white']};
            box-shadow: ${theme.shadows['shadow-04dp']};
        }

        &:focus {
            box-shadow: ${theme.shadows['outline']};
        }

        &:active {
            box-shadow: none;
        }

        &:hover {
            background-color: ${theme.colors['myzanichelli-blue-dark']};
        }

        &::-moz-focus-inner {
            border: 0;
        }
    `}
`;

const PlayPauseButton = ({ running, onClick, ariaLabel, ariaControls }) => {
    return (
        <Button onClick={onClick} onMouseUp={(event) => event.target.blur()} aria-label={ariaLabel} aria-controls={ariaControls}>
            {running ? <PauseIcon /> : <PlayIcon />}
        </Button>
    );
};

PlayPauseButton.propTypes = {
    running: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string.isRequired,
    ariaControls: PropTypes.string.isRequired,
};

export default PlayPauseButton;
